import {sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {AutoplaySpinUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplaySpinUIAct';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {AutoplayDelayBetweenSpinsUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayDelayBetweenSpinsUIAct';
import {AutoplayCheckNextSpinUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayCheckNextSpinUIAct';
import {JurisdictionZoneUpdateSessionBetUIAct} from '@gongxigames/framework/slotV2/ui/acts/JurisdictionZoneUpdateSessionBetUIAct';
import {AutoplayEnableSpinAutoModeUIAct} from '@gongxigames/framework/slotV2/ui/acts/autoplay/AutoplayEnableSpinAutoModeUIAct';

export class AutoplaySpinUIState extends UIState {
    public static readonly ID = 'AutoplaySpinUIState';

    public setAct(): void {
        this.act = sequence([
            JurisdictionZoneUpdateSessionBetUIAct,
            AutoplayDelayBetweenSpinsUIAct,
            AutoplayEnableSpinAutoModeUIAct,
            AutoplaySpinUIAct,
            AutoplayCheckNextSpinUIAct
        ]);
    }

    public canExecute(): boolean {
        return slotStore.isAutoplay.value;
    }
}